import { ActionTypes } from "../../constants/action-types";

const initialState = {
    analytics: [],
    is_analytics: false
};

export const analyticsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.SET_ANALYTICS:
            return {
                ...state,
                analytics: payload,
                is_analytics: true
            };

        case ActionTypes.RESET_STORE:
            return {
                ...state = initialState
            }

        default:
            return state;
    }
};
